import z from "zod";

import {
    AttendanceStatusEnum,
    AttendanceTypeEnum,
    type AttendanceTypeUnion,
    isAttendanceTypeEnum,
    TimesheetsDateModeEnum,
    type TimesheetsDateModeUnion,
    TimesheetsSearchModeEnum,
    type TimesheetsSearchModeUnion,
} from "@lib/attendance/searchEnums";
import { i18n } from "@lib/i18n";
import { globalLayoutRoute } from "@routes";
import { requireScope } from "@routes/authorization";
import {
    api_pkg_attendance_dto_StatusSchema,
    api_pkg_attendance_dto_TypeSchema,
} from "@sdk/schemas";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export {
    AttendanceStatusEnum,
    AttendanceTypeEnum,
    isAttendanceTypeEnum,
    TimesheetsDateModeEnum,
    TimesheetsSearchModeEnum,
    type AttendanceTypeUnion,
    type TimesheetsDateModeUnion,
    type TimesheetsSearchModeUnion,
};

const TimesheetsSearchSchema = z.object({
    status: z.array(api_pkg_attendance_dto_StatusSchema).default(["att.waiting"]),
    type: z.array(api_pkg_attendance_dto_TypeSchema).optional(),
    dateMode: TimesheetsDateModeEnum.default("all").optional(),
    day: z.coerce.date().optional(),
    week: z.string().optional(),
    month: z.string().optional(),
    searchMode: TimesheetsSearchModeEnum.default("sider").optional(),
    search: z.string().optional(),
    siderId: z.string().optional(),
    managerId: z.string().optional(),
});

export const timesheetsRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `timesheets`,
    component: lazyRouteComponent(() => import("./components/Timesheets")),
    validateSearch: TimesheetsSearchSchema,
    beforeLoad: () => {
        requireScope("account");
        return { getTitle: () => i18n.doc_title_timesheets() };
    },
});
